"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _ = require("../");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "block",
    position: "relative"
  },
  header: {
    position: "absolute",
    zIndex: 2,
    top: 0,
    right: 0,
    bottom: "auto",
    left: 0,
    height: theme.spacing(15),
    borderBottom: "1px solid #ccc",
    borderColor: "#ccc"
  },
  footer: {
    position: "absolute",
    zIndex: 3,
    top: 0,
    right: 0,
    bottom: "auto",
    left: "auto",
    margin: theme.spacing(2)
  },
  body: {
    position: "absolute",
    zIndex: 1,
    top: theme.spacing(15),
    right: 0,
    bottom: 0,
    left: 0
  },
  title: {
    fontSize: "20px",
    fontWeight: "normal",
    lineHeight: "30px",
    margin: "20px"
  },
  description: {
    fontSize: "14px",
    fontWeight: "bold",
    lineJeight: "24px",
    position: "absolute",
    top: "auto",
    right: 0,
    bottom: 0,
    left: 0,
    margin: "20px",
    marginBottom: "12px"
  }
}));

const InboxWidget = (_ref) => {
  let title = _ref.title,
      description = _ref.description,
      button = _ref.button,
      url = _ref.url,
      data = _ref.data,
      onSelect = _ref.onSelect,
      props = _objectWithoutPropertiesLoose(_ref, ["title", "description", "button", "url", "data", "onSelect"]);

  const classes = useStyles();
  const results = data.results || data.models || [];
  const resultsCount = data.count || results.length || undefined;
  const resultsRows = data.rows || results.length;
  description = description.replace("{rows}", resultsRows);
  description = description.replace("{count}", resultsCount);
  return _react.default.createElement(_.WidgetBase, _extends({}, props, {
    size: props.size || props.widgetSize
  }), _react.default.createElement("header", {
    className: classes.header
  }, _react.default.createElement(_Typography.default, {
    component: "h2",
    className: classes.title
  }, title), _react.default.createElement(_Typography.default, {
    component: "h3",
    className: classes.description
  }, description)), _react.default.createElement(_.WidgetScroller, {
    className: classes.body
  }, _react.default.createElement(_.InboxResults, {
    results: results,
    onSelect: onSelect
  })), _react.default.createElement("footer", {
    className: classes.footer
  }, _react.default.createElement(_.WidgetButton, _extends({}, button, {
    onClick: () => onSelect(button)
  }))));
};

InboxWidget.defaultProps = {
  size: "12:6",
  title: "Inbox",
  description: "{rows} of {count} messages",
  button: {
    "url": "/inbox",
    "label": "Go to Inbox"
  },
  urlPattern: "/inbox/:uniqueId",
  data: {
    results: []
  }
};
var _default = InboxWidget;
exports.default = _default;
module.exports = exports.default;